import React from 'react';

function Footer() {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="relative bg-slate-800 pt-20 pb-8 text-white overflow-hidden">
      {/* Angled top border */}
      <div className="absolute top-0 left-0 w-full h-20">
        {/* Make sure this background matches your page's main background, e.g., bg-slate-50 */}
        <div className="absolute top-0 left-0 w-1/2 h-full bg-slate-50 transform -skew-y-2 origin-top-left"></div>
        <div className="absolute top-0 right-0 w-1/2 h-full bg-slate-50 transform skew-y-2 origin-top-right"></div>
      </div>

      {/* Footer Content */}
      <div className="relative mt-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center">
        {/* Logo/Brand Name */}
        <div className="mb-6 sm:mb-0 cursor-pointer" onClick={() => handleScroll("hero")}>
          <p className="text-xl font-bold tracking-wider">AI-Worker</p>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center items-center gap-x-6 sm:gap-x-8 gap-y-4 text-slate-300 font-medium">
          <button
            onClick={() => handleScroll("pricing")}
            className="hover:text-cyan-400 transition-colors duration-300"
          >
            Pricing Plans
          </button>
          <button
            onClick={() => handleScroll("benefits")}
            className="hover:text-cyan-400 transition-colors duration-300"
          >
            Who It's For
          </button>
          <button
            onClick={() => handleScroll("how-it-works")}
            className="hover:text-cyan-400 transition-colors duration-300"
          >
            How It Works
          </button>
          <button
            onClick={() => handleScroll("about")}
            className="hover:text-cyan-400 transition-colors duration-300"
          >
            About Us
          </button>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center text-slate-400 text-sm mt-8">
        © {new Date().getFullYear()} AI Worker. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
